import { JetView } from 'webix-jet';

/**
 * Class representing the details bonus report view.
 * @extends JetView
 */
export default class detailsBonusReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Main information form structure
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: _("<span class='icon-id'></span> ID"), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Id'), // Placeholder text
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'), // Label for type
                    labelPosition: 'top',
                    placeholder: _('Tipo'), // Placeholder for type
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Date',
                    label: _('Fecha'), // Label for date
                    labelPosition: 'top',
                    placeholder: _('Fecha'), // Placeholder for date
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Monto'), // Label for amount
                    labelPosition: 'top',
                    placeholder: _('Monto'), // Placeholder for amount
                    disabled: true, // Field is disabled
                    id: 'Monto', // Unique ID for amount field
                },
            ],
        };

        // Left main section layout
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Contains main_info
        };

        // Upper section layout for larger screens
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 20 }], // Columns layout
        };

        // Upper section layout for narrow screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info], // Contains main_info
                },
            ],
        };

        // Return the final form configuration
        return {
            view: 'form',
            rows: [screen !== 'small' ? upper_section : upper_section_narrow], // Conditional layout based on screen size
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        // Event listener for selecting a bonus transaction detail
        this.on(this.app, 'bonusTransDetail:select', (person) => {
            form.setValues(person); // Set form values based on selected person
            this.$$('Monto').setValue(webix.i18n.priceFormat(person.Amount)); // Format and set amount value
        });
    }
}

// FILE DOCUMENTED
